import { render } from "./QuestionnaireComponent.vue?vue&type=template&id=f6b3bb9c&scoped=true"
import script from "./QuestionnaireComponent.vue?vue&type=script&lang=js"
export * from "./QuestionnaireComponent.vue?vue&type=script&lang=js"

import "./QuestionnaireComponent.vue?vue&type=style&index=0&id=f6b3bb9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b3bb9c"]])

export default __exports__